<script setup lang="ts">
/**
 * Final Dividends — Dividend Voucher (주주 1인당 1부, mem_${id}/ 스코프).
 *   원본: Dividend Voucher (QA #1 수정: interim → final).
 *   서명 = 이사 1인([[Signing_Director_Signature]]).
 */
import CddVarField from '../cdd/CddVarField.vue';
import AgmSigners from '../cdd/AgmSigners.vue';
import './agmDoc.css';
</script>

<template>
  <div class="agm-doc">
    <div class="doc-head">
      <div><b><CddVarField field-key="company_name" label="Company Name" /></b></div>
      <div>Company Registration No. <CddVarField field-key="company_registration_no" label="Reg No" /></div>
      <div>(Incorporated in the Republic of Singapore)</div>
      <div>(the &ldquo;Company&rdquo;)</div>
      <div>Registered Office: <CddVarField field-key="registered_office_address" label="Registered Office Address" /></div>
    </div>

    <table class="cdd-tbl">
      <tbody>
        <tr>
          <td class="cdd-lcell">Dividend No.</td><td><CddVarField field-key="dividend_number" label="Dividend Number" /></td>
          <td class="cdd-lcell">Date</td><td><CddVarField field-key="payment_date" label="Payment Date" /></td>
        </tr>
      </tbody>
    </table>

    <p class="doc-p">
      <CddVarField field-key="member_name" label="Member Name" /><br />
      <CddVarField field-key="member_address" label="Member Address" />
    </p>
    <p class="doc-p">Dear Sir/Madam,</p>
    <p class="doc-p">
      We are pleased to advise that a final dividend of <CddVarField field-key="total_dividend_amount" label="Total Dividend Amount" />
      under One-Tier Corporate Tax System has been declared out of profits of the company, for the financial year ending
      <CddVarField field-key="financial_year_end" label="Financial Year End" />.
    </p>
    <p class="doc-p">The amount due in respect of the shares registered in your name as of <CddVarField field-key="payment_date" label="Payment Date" /> is as follows:</p>

    <table class="cdd-tbl">
      <tbody>
        <tr><td>Dividend on <CddVarField field-key="number_of_shares" label="Number of Shares" /> ordinary shares</td><td><CddVarField field-key="amount_to_receive" label="Amount To Receive" /></td></tr>
        <tr><td>Less: Singapore Income Tax</td><td></td></tr>
        <tr><td>Tax Exempt (one-tier)</td><td></td></tr>
        <tr><td><b>Amount Due</b></td><td><CddVarField field-key="amount_to_receive" label="Amount To Receive" /></td></tr>
      </tbody>
    </table>

    <p class="doc-p">Yours faithfully,</p>
    <div class="sign-block">
      <AgmSigners var-key="signing_director_Signers" board-label="Director" />
    </div>

    <p class="doc-note">
      NOTE:<br />
      This notice constitutes the certificate required under the Income Tax Legislation and should be carefully preserved as only this
      original will be accepted by the Income Tax authorities in connection with any claim to allowance or relief from Income Tax.<br />
      Please notify of any change of address.
    </p>
  </div>
</template>
